export default function Err404 () {

    return(
        <>
            <h2>404</h2>
        </>
    )
}